module.exports = __webpack_public_path__ + "static/img/1.06ae24f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/1.png
// module id = wzry
// module chunks = 0